import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getRefundBeneficiaries} from '../../services/getRefundBeneficiaries';
import type {UseGetRefundBeneficiariesQueryProps} from './types';

export const useGetRefundBeneficiariesQuery = ({
	enabled = false,
}: UseGetRefundBeneficiariesQueryProps) =>
	useQuery({
		queryKey: [QUERY_KEYS.REFUND_BENEFICIARIES],
		queryFn: async ({signal}) => getRefundBeneficiaries(signal),
		enabled,
	});
